<template>
  <TransitionRoot appear :show="open" as="template">
    <Dialog as="div" static :open="open" @close="$emit('close')">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay
              class="fixed inset-0 bg-neutral-40 bg-opacity-50 backdrop-blur-sm backdrop-filter transition-opacity"
            />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="inline-block h-screen align-middle" aria-hidden="true"> &#8203; </span>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="inline-block transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:px-10 sm:py-8 sm:align-middle"
            >
              <div v-if="showX" class="absolute right-0 top-0 pr-8 pt-8">
                <button
                  tabindex="-1"
                  type="button"
                  class="rounded-md bg-white text-neutral-40 hover:text-neutral-20 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  @click="$emit('close')"
                >
                  <span class="sr-only">Close</span>
                  <XIcon class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div class="sm:flex sm:items-start">
                <div class="sm:mt-0 sm:text-left">
                  <DialogTitle as="h3" class="mb-6 mt-0 text-lg font-semibold leading-6 text-neutral-0">
                    <slot name="title">{{ title }}</slot>
                  </DialogTitle>
                  <div>
                    <slot name="content"></slot>
                  </div>
                </div>
              </div>
              <div class="mt-5 flex space-x-4 space-x-reverse sm:mt-4 sm:flex sm:flex-row-reverse">
                <slot name="buttons"></slot>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay, DialogTitle } from "@headlessui/vue";
import { XIcon } from "@heroicons/vue/outline";

export default {
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,

    XIcon,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    showX: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
  },
  emits: ["close"],
};
</script>
